export default {
	subtitle: "Refunded Payment Notification",
  path: "payment_notification_refund",
	paragraph: "If you want to enable the feature of not accepting payments from third parties you will recieve this webhook to let you know that a payment was refunded for this motive. If a dynamic Pix QR code was paid from an account whose ownership is different than of the specified subject_id in the transaction, we will automatically refund the payer and send you this following webhook: ",
	request: {
		method: "POST",
		payloads: [
		 {
			title: "Notification",
			content: {
    			"notification": {
					"type": "payment_refunded",
					"transaction_id": "UUID",
					"secret": "the value you received"
				}
			 }
		  }
		]
	}
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/NotificationPaymentRefund.js